import {
  NodeBasicPage,
  NodeCrisisBanner,
  NodeVacancyPage,
  NodeLandingPage,
  NodeHome,
  NodeArticle,
  NodePerson,
  NodeFaqItem,
  NodeProduct,
  NodeHelpPage,
} from '../implementations';

const mappers = {
  basic_page: NodeBasicPage,
  crisis_banner: NodeCrisisBanner,
  vacancy: NodeVacancyPage,
  landing_page: NodeLandingPage,
  home: NodeHome,
  article: NodeArticle,
  person: NodePerson,
  product: NodeProduct,
  faq_item: NodeFaqItem,
  help_page: NodeHelpPage,
};

export default mappers;
